<template>
  <div v-if="grades.length">
    <div class="detail-layout-section-title">
      <h3>{{ $texts('accessibility', 'Accessibility') }}</h3>
    </div>

    <figure class="travel-details">
      <table class="is-fullwidth mb-0 table">
        <tbody>
          <tr v-for="rating in grades" :key="rating.gradeName">
            <th>{{ rating.ratingProfileName }}</th>
            <td class="!pr-0 !text-right">
              {{ rating.gradeName }}
              <span :class="`grade-color grade-color--${rating.grade}`" />
            </td>
          </tr>
        </tbody>
      </table>
    </figure>

    <div>
      <a
        v-if="url"
        :href="url"
        target="_blank"
        rel="noopener"
        class="link with-arrow mt-size-6"
      >
        {{ $texts('moreInformation', 'More information') }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DiscoverSwissAccessibilityFragment } from '#build/graphql-operations'
import { notNullish } from '@vueuse/core'

const props = defineProps<{
  nid: string
}>()

const langcode = useCurrentLangcodeEnum()

const { data } = await useAsyncGraphqlQuery(
  'loadAccessibilityInfo',
  { id: props.nid, langcode: langcode.value },
  {
    transform: function (data) {
      const entity = data.data.entityById
      if (
        entity &&
        'discoverSwissItem' in entity &&
        entity.discoverSwissItem?.poi
      ) {
        return entity.discoverSwissItem.poi
      }

      return null
    },
    deep: false,
    graphqlCaching: {
      client: true,
    },
    watch: [langcode],
  },
)

const grades = computed<DiscoverSwissAccessibilityFragment[]>(() =>
  (data.value?.accessibility || []).filter(notNullish),
)

const url = computed<string | undefined>(() => {
  const link = data.value?.link?.find((v) => v?.type === 'GintoWeb')
  return link?.url
})
</script>

<style lang="postcss" scoped>
.grade-color {
  @apply ml-2.5 inline-block h-3.5 w-3.5 rounded-full;

  &--1 {
    @apply bg-success;
  }
  &--2 {
    @apply bg-warning;
  }
  &--3 {
    @apply bg-danger;
  }
}
</style>
